requirejs.config({
    paths: {
        'text': '../content/lib/require/text',
        'durandal': '../content/lib/durandal/js',
        'plugins': '../content/lib/durandal/js/plugins',
        'transitions': '../content/lib/durandal/js/transitions',
        'knockout': '../content/lib/knockout/knockout-3.2.0',
        'knockout-mapping': '../content/lib/knockout/knockout.mapping-latest',
        'bootstrap': '../content/lib/bootstrap/js/bootstrap.min',
        'moment': '../content/lib/moment.min',
        'utils': '../content/lib/utils',
        'datepicker': '../content/lib/datepicker/bootstrap-datepicker',
        'jquery': '../content/lib/jquery/jquery-1.9.1.min',
        'jqueryui': '../content/lib/jquery/jquery-ui-1.10.4.custom.min',
        'jstree': '../content/lib/jstree/jstree',
        'tinycolorpicker': '../content/lib/tinycolorpicker/jquery.tinycolorpicker.min', // custom build with mouse / touchscreen fix, "no color" config option and ".open" state CSS class hook
        'leaflet-viewport': '../content/lib/leaflet/plugins/leaflet-viewport',
        'leaflet-attribution': '../content/lib/leaflet/plugins/leaflet-attribution',
        'leaflet-text-block': '../content/lib/leaflet/plugins/leaflet-text-block',
        'leaflet-legend': '../content/lib/leaflet/plugins/leaflet-legend',
        'leaflet-tile-nogap': '../content/lib/leaflet/plugins/L.TileLayer.NoGap',
        'leaflet-tile-wms-nogap': '../content/lib/leaflet/plugins/L.TileLayer.WMS.NoGap',
        'leaflet-minimap': '../content/lib/leaflet/plugins/leaflet-draggable-minimap',
        'leaflet-draw': '../content/lib/leaflet/plugins/draw/leaflet.draw-src',
        'leaflet-geosearch': '../content/lib/leaflet/plugins/geosearch/l.control.geosearch',
        'leaflet-geosearch-eme': '../content/lib/leaflet/plugins/geosearch/l.geosearch.provider.eme',
        'leaflet-title': '../content/lib/leaflet/plugins/leaflet-title',
        'spin': '../content/lib/spin/spin',
        'leaflet-scalebar': '../content/lib/leaflet/plugins/leaflet-scalebar',
        'leaflet-tilelayer-switch': '../content/lib/leaflet/plugins/leaflet-tilelayer-switch',
        'leaflet-omnivore': '../content/lib/leaflet/plugins/leaflet-omnivore',
        'summernote': '../content/lib/summernote/summernote.min', // n.b. using custom build that removes codemirror stuff https://github.com/grahamkane/summernote/commit/a7ba4c4b89e9be450cebf40a07804119c858df03
        'dropzone': '../content/lib/dropzone/dropzone',
        'no-ui-slider': '../content/lib/noUiSlider/jquery.nouislider.min',
        'bowser': '../content/lib/bowser/bowser.min',
    },
    shim: {
        'bootstrap': {
            deps: ['jquery'],
            exports: 'bootstrap'
        },
        'moment': {
            exports: 'moment'
        },
        'dropzone': {
            exports: 'dropzone'
        },
        'utils': {
            deps: ['jquery', 'knockout'],
            exports: 'utils'
        },
        'datepicker': {
            deps: ['bootstrap'],
            exports: 'datepicker'
        },
        'jqueryui': {
            deps: ['jquery']
        },
        'tinycolorpicker': {
            deps: ['jquery']
        },
        'jstree': {
            deps: ['jquery']
        },
        'summernote': {
            deps: ['jquery']
        },
        'leaflet-geosearch-eme': {
            deps: ['leaflet-geosearch']
        },
        'knockout-mapping': {
            deps: ['knockout']
        }
    }
});

define('main',['durandal/system', 'durandal/app', 'durandal/viewLocator', 'plugins/http', 'jquery'], function (system, app, viewLocator, http, $) {
    //>>excludeStart("build", true);
    system.debug(true);
    //>>excludeEnd("build");

    app.title = 'mapForge';
    app.version = 'v 1.4.6';

    app.configurePlugins({
        router: true,
        dialog: true,
        widget: true
    });

    // set up global ajax handling for user re-authentication
    $.ajaxSetup({
        statusCode: {
            401: function () {
                window.location.href = '/?returnUrl=' + window.location.pathname;
            },
            403: function () {
                window.location.href = '/?returnUrl=' + window.location.pathname;
            }
        }
    });

    http.jsonp('/api/auth/current').then(function (response) {
        app.currentUser = response;

        app.start().then(function () {
            // Look for views from the current folder (app) instead of convention 'views'
            viewLocator.convertModuleIdToViewId = function (moduleId) {
                return moduleId;
            };

            this.translateViewIdToArea = function (viewId) {
                return viewId;
            };

            var allow = app.currentUser.authenticated || window.location.href.indexOf('authbypasskey') !== -1;

            //Show the app by setting the root view model for our application with a transition.
            app.setRoot(allow ? 'shell' : 'login');
        });
    });
});
